import { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/ui";
import { elapsedSince, formatDuration, splitDuration } from "./time";

export const Timer = forwardRef<
  HTMLDivElement,
  {
    revealedAt: string;
    serverNow: string;
    receivedAt: number;
    frozenMs: number | null;
    /** The solve just happened on this page: the clock punches once as it stops. */
    landed?: boolean;
  }
>(function Timer({ revealedAt, serverNow, receivedAt, frozenMs, landed = false }, ref) {
  const { t } = useTranslation();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (frozenMs !== null) return;
    const id = window.setInterval(() => setNow(Date.now()), 500);
    return () => window.clearInterval(id);
  }, [frozenMs]);
  const ms = frozenMs ?? elapsedSince(revealedAt, serverNow, receivedAt, now);
  const { lead, seconds } = splitDuration(ms);
  return (
    <div
      ref={ref}
      className={cn(
        "bt-timer",
        frozenMs !== null && "bt-timer--final",
        landed && "bt-timer--landed",
      )}
      aria-live="off"
      // The split is a visual treatment; a screen reader gets the whole reading.
      aria-label={`${t("play.timer")} ${formatDuration(ms)}`}
    >
      <span aria-hidden="true">{lead}</span>
      <span aria-hidden="true" className="bt-timer__seconds">
        {seconds}
      </span>
    </div>
  );
});
